import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { capitalizeText, pluralDays, preparePrice } from '../../helpers/lib';
import { DiscountSvg } from './DiscountSvg';

const DiscountMessage = ({ discountDaysLeft, discountPrice, fullPrice }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <DiscountSvg />
      <Typography variant="desktopP3" color={'kit.text.main'}>
        {' '}
        {`${capitalizeText(pluralDays(discountDaysLeft))} - `}
      </Typography>
      <Typography
        variant="desktopP3"
        color={'kit.text.main'}
        fontWeight={'bold'}
      >
        {`${preparePrice(discountPrice)} ₽`}
      </Typography>
      <Typography variant="desktopP3" color={'kit.text.main'}>
        {`вместо ${preparePrice(fullPrice)} ₽`}
      </Typography>
    </Box>
  );
};

export function NotificationChip({ group }) {
  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: 492,
        height: '32px',
        mb: { xl: 3, xs: 1 },
      }}
    >
      {group.daysBeforeStartLeft && (
        <Chip
          color="secondary"
          size="small"
          variant="status"
          label={
            group.isDiscount ? (
              <DiscountMessage
                discountDaysLeft={group.discountDaysLeft}
                fullPrice={group.price.fullPrice}
                discountPrice={group.price.discountPrice}
              />
            ) : (
              <Typography variant="desktopP3" color={'kit.text.main'}>
                До старта курса {pluralDays(group.daysBeforeStartLeft)}
              </Typography>
            )
          }
          sx={{
            width: '100%',
            borderRadius: 16,
            my: 1,
            height: 32,
            textTransform: 'none',
            fontWeight: 400,
            backgroundColor: group.isDiscount
              ? '#F4F2FA !important'
              : '#29EDFF !important',
          }}
        />
      )}
    </Box>
  );
}
